import { render, staticRenderFns } from "./album-detail.vue?vue&type=template&id=38df6f6f&scoped=true"
import script from "./album-detail.vue?vue&type=script&lang=js"
export * from "./album-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df6f6f",
  null
  
)

export default component.exports